export const STATIC_APP_BAR_ROUTES = {
  '/email-verification/:identifier': 'email-verification',
}